var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditorImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 5.25A2.624 2.624 0 0 1 5.25 2.625h10.5a2.624 2.624 0 0 1 2.625 2.625v10.5a2.624 2.624 0 0 1-2.582 2.625L8.566 9.088a.875.875 0 0 0-1.382 0l-4.559 5.865V5.25zm.452 11.973a2.621 2.621 0 0 0 2.173 1.152h8.325l-5.7-7.325-4.798 6.173zm12.28 2.902H5.25A4.374 4.374 0 0 1 .875 15.75V5.25A4.374 4.374 0 0 1 5.25.875h10.5a4.374 4.374 0 0 1 4.375 4.375v10.5a4.374 4.374 0 0 1-4.375 4.375h-.393zM14 6.125a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75zM11.375 7a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0z",
    fill: "#8A8DAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorImage);
export default __webpack_public_path__ + "static/media/editor_image.5b623670e8f306031bab09b1ffbca3e4.svg";
export { ForwardRef as ReactComponent };